import styled, {keyframes} from 'styled-components';
import {curves, injectSafeTop, injectAdaptive} from 'ui/theme';

const intro = keyframes`
  from {
    transform: scale(0.1);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
`;

export const Wrapper = styled.div`
  max-width: 360px;
  margin: auto;
  padding: 0;
  line-height: 1.4;
  text-align: center;
  ${injectSafeTop('padding')}
`;

export const Content = styled.div`
  ${injectAdaptive('padding-top', ['35px', '35px', '40px', '40px', '45px'])}
  ${injectAdaptive('padding-bottom', ['30px', '40px', '50px', '55px', '65px'])}
`;

export const Title = styled.div`
  ${injectAdaptive('font-size', ['55px', '60px', '66px', '72px', '90px'])}
  padding-bottom: 5px;
  font-weight: 700;
  line-height: 1;
  animation: ${intro} 0.3s ${curves.easeOutBack};
`;
